import { FC, HTMLAttributes, ElementType, ReactNode } from 'react';

import './Stack.css';

interface StackProps extends HTMLAttributes<HTMLDivElement> {
  direction?: 'vertical' | 'horizontal';
  align?: 'start' | 'center' | 'end';
  justify?: 'start' | 'center' | 'end' | 'between' | 'around';
  gap?: 'no' | 'xs' | 'sm' | 'md' | 'lg';
  fill?: boolean;
  as?: ElementType;
  wrap?: boolean;
}

const Stack: FC<StackProps> = ({ 
  children, 
  direction = 'vertical',
  align = 'start',
  justify = 'start',
  fill = false,
  gap = 'md',
  className = '',
  as: Element = 'div',
  wrap = false,
  ...props 
}) => {

  let classNames = [
    className,
    'stack',
    direction === 'horizontal' ? 'is-horizontal' : '',
    align === 'center' ? 'align-center' : align === 'end' ? 'align-end' : '',
    justify === 'center' ? 'justify-center' : justify === 'end' ? 'justify-end' : justify === 'between' ? 'justify-between' : justify === 'around' ? 'justify-around' : '',
    gap !== 'md' ? `gap-${gap}` : '',
    fill ? 'fill' : '',
    wrap ? 'stack--wrap' : '',
  ];

  classNames = classNames.filter(Boolean);

  return (
    <Element 
      className={classNames.join(' ')}
      {...props}
    >
      {children}
    </Element>
  );
};

export default Stack;
